import { useEffect, useState } from 'react'
import './styles.css'

const Project = ({ empty = false, selected, project, setSelected }) => {
	const [isSelected, setIsSelected] = useState(false)
	const handleSelectProject = () => {
		if (JSON.stringify(selected) === JSON.stringify(project)) {
			setSelected(null)
		} else {
			setSelected(project)
		}
	}
	useEffect(() => {
		if (JSON.stringify(selected) === JSON.stringify(project)) {
			setIsSelected(true)
		} else {
			setIsSelected(false)
		}
	}, [selected])

	if (!empty) {
		return (
			<div onClick={handleSelectProject} className={isSelected ? 'projectField selected' : 'projectField'}>
				<span className="projectName">{project.name}</span>
			</div>
		)
	} else {
		return (
			<div className="projectField">
				<span className="projectName">Carregando...</span>
			</div>
		)
	}
}

export default Project
